document.querySelectorAll('.internal-video').forEach(container => {
  const video = container.querySelector('video');
  const playBtn = container.querySelector('.internal-video__play');

  if (!video) return;

  const shouldAutoplay = container.classList.contains('is-autoplay');

  if (shouldAutoplay) {
    video.play().catch(() => {
      if (playBtn) playBtn.style.visibility = 'visible';
    });
  }

  if (playBtn) {
    playBtn.addEventListener('click', () => {
      video.play();
      playBtn.style.display = 'none';
    });
  }
});


class SplideComponent extends HTMLElement {
  connectedCallback() {
    // Attendre que le DOM soit prêt + éviter que le composant s'initialise trop tôt
    requestAnimationFrame(() => {
      const el = this;

      // Vérifie si un slider est déjà monté
      const splide = el.querySelector('.splide');
      if (!splide || splide.classList.contains('splide--mounted')) return;

      // Lire les attributs data
      const type = el.dataset.type || 'slide';
      const autoplay = el.dataset.autoplay === 'true';
      const interval = (parseFloat(el.dataset.autoplaySpeed) || 3) * 1000;

      const arrowsColor = el.dataset.arrowsColor || 'default';
      const dotsColor = el.dataset.dotsColor || 'default';

      const perPageDesktop = parseInt(el.dataset.slidesDesktop) || 1;
      const perMoveDesktop = parseInt(el.dataset.perMoveDesktop) || 1;
      const gapDesktop = el.dataset.gapDesktop || '1rem';
      const sidePaddingDesktop = el.dataset.sidePaddingDesktop || '0px';
      const paddingCalcDesktop = el.dataset.paddingCalcDesktop === 'true';

      const perPageMobile = parseInt(el.dataset.slidesMobile) || 1;
      const gapMobile = el.dataset.gapMobile || '1rem';
      const sidePaddingMobile = el.dataset.sidePaddingMobile || '0px';

      const destroyDesktop = el.dataset.destroyDesktop === 'true';
      const destroyMobile = el.dataset.destroyMobile === 'true';

      const pauseVideos = el.dataset.pauseVideos === 'true';

      const isMobile = window.innerWidth < 768;
      if ((isMobile && destroyMobile) || (!isMobile && destroyDesktop)) return;

      // Padding dynamique
      const paddingDesktop = paddingCalcDesktop
        ? { left: sidePaddingDesktop, right: sidePaddingDesktop }
        : sidePaddingDesktop;

      const paddingMobile = {
        left: sidePaddingMobile,
        right: sidePaddingMobile,
      };

      // Initialisation du slider
      new Splide(splide, {
        type,
        autoplay,
        interval,
        perPage: perPageDesktop,
        perMove: perMoveDesktop,
        gap: gapDesktop,
        padding: paddingDesktop,
        arrows: true,
        pagination: true,
        pauseOnHover: pauseVideos,
        breakpoints: {
          768: {
            perPage: 1,
            gap: gapMobile,
            padding: paddingMobile,
          },
        },
      }).mount();

      splide.classList.add('splide--mounted'); // marquer comme monté
    });
  }
}

if (!customElements.get('splide-component')) {
  customElements.define('splide-component', SplideComponent);
}

class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector("button");
    this.scrollDestination = this.dataset.scrollDestination || null;
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.showAfterScroll = this.dataset.afterScroll === "true";

    if (this.button) {
      this.button.addEventListener("click", this.handleClick);
    }

    if (this.showAfterScroll) {
      this.atcTarget = document.querySelector(".product-form__submit");

      if (this.atcTarget) {
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll(); // déclenchement initial
      }
    } else {
      this.classList.add("is-visible");
    }
  }

  handleScroll() {
    if (!this.atcTarget) return;

    const scrollY = window.scrollY;
    const atcTop = this.atcTarget.offsetTop;
    const atcHeight = this.atcTarget.offsetHeight;
    const threshold = atcTop + atcHeight;

    if (scrollY > threshold) {
      this.classList.add("is-visible");
    } else {
      this.classList.remove("is-visible");
    }
  }

  handleClick(e) {
    e.preventDefault();

    if (this.isScrollBtn && this.scrollDestination) {
      let target = null;

      if (this.scrollDestination === "#ProductInfo-id") {
        target = document.querySelector('[id^="offer_block"]');
      } else {
        target = document.querySelector(this.scrollDestination);
      }

      if (target) {
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;

        const offset = target.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    } else {
      const mainBtn = document.querySelector(".product-form__submit");
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      }
    }
  }
}

customElements.define("sticky-atc", StickyATC);


function updateStickyATCOffset() {
  const sticky = document.querySelector('sticky-atc');
  if (!sticky || !sticky.classList.contains('is-visible')) return;

  const height = sticky.offsetHeight;
  const offset = 2; // marge de sécurité

  sticky.style.bottom = `${offset}px`;
}

window.addEventListener('resize', updateStickyATCOffset);
window.addEventListener('load', updateStickyATCOffset);

// Optionnel : recalcule aussi quand on affiche la sticky
const observer = new MutationObserver(() => {
  updateStickyATCOffset();
});
observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });